<template>
  <div id="workflowsProcesses">
    <card :title="$t('w-processes:filter')" :visible.sync="filterVisibility" collapsible>
      <div slot="card-body">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="name" class="control-label">{{ $t('w-processes:name') | capitalize }}</label>
            <input id="name"
                   v-model="filterName"
                   v-validate="'text'"
                   :data-vv-as="$t('w-processes:name')"
                   :class="{ 'is-invalid': errors.has('name') }"
                   type="text"
                   name="name"
                   class="form-control"
            >
            <div class="invalid-feedback">{{ errors.first('name') }}</div>
          </div>
        </div>
      </div>

      <div slot="card-footer">
        <button id="filterButton" class="btn btn-primary" @click="filter()">{{ $t('w-processes:search') | capitalize }}</button>
      </div>
    </card>

    <grid id="workflowProcessesGrid"
          :title="$t('w-processes:' + state)"
          :columns="columns"
          :paginated-dto="processes"
          @load="filter"
    >
      <template slot="workflow" slot-scope="props">
        <router-link v-if="props.dto.id" :to="'/workflows/' + props.dto.id">{{ props.dto.templateName }}</router-link>
        <template v-else>{{ props.dto.templateName }}</template>
      </template>
      <template slot="startTime" slot-scope="props">{{ props.dto.startTime | date }}</template>
      <template slot="endTime" slot-scope="props">{{ props.dto.endTime | date }}</template>
    </grid>
  </div>
</template>

<script>
import to from '@/modules/await-to-js'

export default {
  titleKey: 'workflowsProcesses',

  props: {
    // state of the processes ["running", "completed"]
    state: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      // Filter
      filterVisibility: false,
      filterName: '',
      // Grid
      processes: {}
    }
  },

  computed: {
    columns () {
      const columns = [{ text: this.$t('w-processes:workflow'), slot: 'workflow', sort: 'templateName' }]

      if (this.state === 'running') {
        columns.push({ text: this.$t('w-processes:nbPending'), formatter: group => group.nbPending })
      }

      columns.push({ text: this.$t('w-processes:nbSuccess'), formatter: group => group.nbSuccess })
      columns.push({ text: this.$t('w-processes:nbFail'), formatter: group => group.nbFail })
      columns.push({ text: this.$t('w-processes:startTime'), slot: 'startTime', sort: 'startTime' })

      if (this.state === 'completed') {
        columns.push({ text: this.$t('w-processes:endTime'), slot: 'endTime', sort: 'endTime' })
      }

      return columns
    }
  },

  watch: {
    state () {
      // Need to reset as this component is used in two pages
      this.filterVisibility = false
      this.filterName = ''
      this.processes = {}
    }
  },

  created () {
    this.filter()
  },

  methods: {
    async filter (options = {}) {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      // Add filters in query params
      if (this.filterName) options.templateName = this.filterName

      // Get filtered data
      this.getProcesses(options)
    },

    async getProcesses (options) {
      let error, response
      [error, response] = await to(this.$api.getWorkflowProcesses(
        this.$store.getters.application,
        this.$utils.getParams({ sort: '-startTime', ended: this.state === 'completed', templateName: '' }, options, this.queryPageParams)
      ))
      if (error || !response) return

      this.processes = response.data
    }
  }
}
</script>
